<script lang="ts">
	import BtnPrimary from '../buttons/v2/btnPrimary.svelte';
	import { trackEvent } from '$lib/segment/client';
	import Gift from '../icons/gift.svelte';
	import { getFriendbuyContent } from '../api/pages/friendbuy';
	import { slide } from 'svelte/transition';

	const contentPromise = getFriendbuyContent();
</script>

{#await contentPromise then content}
	{@const textWithMarkers = content.bannerLabel.replace(
		/\[(.+)\]/g,
		'<span class="text-green-5">$1</span>'
	)}
	<div in:slide class="relative z-20 flex w-full items-center justify-center bg-green-3 py-3">
		<BtnPrimary
			hasIcon
			size="small-mobile"
			theme="dark"
			onclick={() => trackEvent('Show friendbuy')}
		>
			<span class="inline-flex items-center gap-x-2">
				<span class="text-stone-5">
					{@html textWithMarkers}
				</span>
				<Gift class="h-6 w-6 text-green-5" />
			</span>
		</BtnPrimary>
	</div>
{/await}
